import { render, staticRenderFns } from "./FluxFondosClassicStep3.vue?vue&type=template&id=57715bed"
import script from "./FluxFondosClassicStep3.vue?vue&type=script&lang=js"
export * from "./FluxFondosClassicStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports